import * as MapConstants from '../constants/mapConstants';

const initialState = {
    mobileHideFilter: true,
    mobileHideSearch: true,
    showFullInfoMarkerMobile: false,
};

export default function map(state = initialState, action) {
    switch (action.type) {
        case MapConstants.TOGGLE_MOBILE_HIDE_FILTER:
            return {
                ...state,
                mobileHideFilter: action.mobileHideFilter,
            };
        case MapConstants.TOGGLE_MOBILE_HIDE_SEARCH:
            return {
                ...state,
                mobileHideSearch: action.mobileHideSearch,
            };
        case MapConstants.TOGGLE_SHOW_FULL_INFO_MARKER_MOBILE:
            return {
                ...state,
                showFullInfoMarkerMobile: action.showFullInfoMarkerMobile,
            };
        default:
            return state;
    }
}
